import React, { useState } from 'react';
import useGo, { jump } from '@utils/navigate';
import { useLocation } from 'react-router-dom';
import { Button, Toast } from '@ss/mtd-react-mobile';
import { useRootStore } from '@src/model';
import { LxSiteClick } from '@utils/siteLx';
import { isIos, isWeiXin } from '@utils/tools';
// import { getGoodjobLink } from '@utils/getGoodjobLink';
// @ts-ignore
import avatarImg from '../../../../imgs/avatarImg.png';
import './index.scss';

interface IProps {
  goCallback?: () => void; // 执行跳转前的回调函数
  isLogin: boolean; // 是否已登录
  userInfo: IUserInfo; // 用户信息
  // eslint-disable-next-line react/no-unused-prop-types
  isShowPersonalCenter?: boolean; // 是否展示个人中心
}

interface NavItem {
  code: string;
  text: string;
  linkUrl?: string;
  bid: string;
  isfullUrl?: boolean;
  isExternal?: boolean;
  children?: Array<{
    text: string;
    linkUrl: string;
    isExternal?: boolean;
  }>;
}

export default function NavBar(props: IProps) {
  const { loginStore } = useRootStore();
  const location = useLocation();
  const { isLogin, userInfo, goCallback } = props;
  const { avatar } = userInfo || {};
  const { go } = useGo();
  const [expandedMenu, setExpandedMenu] = useState<string | null>(null);

  const buildEnv = process.env.BUILD_ENV ? process.env.BUILD_ENV : 'inland';

  const navList: NavItem[] = [
    {
      code: 'home',
      text: '首页',
      linkUrl: '/home',
      bid: 'b_ead_x2i1qnqa_mc',
    },
    {
      code: 'longcat',
      text: 'LongCat人才招聘',
      linkUrl:
        buildEnv === 'overseas' ? `${window.origin}/longcatprogram` : 'https://zhaopin.meituan.com/longcatprogram',
      bid: 'b_ead_ally1na4_mc',
    },
    {
      code: 'beidou',
      text: '北斗计划',
      linkUrl: '/beidouprogram',
      bid: 'b_ead_oh5o4nzf_mc',
    },
    {
      code: 'social',
      text: '社会招聘',
      linkUrl: '/social',
      bid: 'b_ead_0y5iw2xj_mc',
    },
    {
      code: 'campus',
      text: '校园招聘',
      linkUrl: '/campus',
      bid: 'b_ead_vkfug8q1_mc',
    },
    {
      code: 'competition',
      text: '美团赛事',
      linkUrl: '/competition',
      bid: 'b_ead_p2bq0gjl_mc',
    },
    // {
    //   code: 'gzjz',
    //   text: '工作兼职',
    //   linkUrl: getGoodjobLink(),
    //   isfullUrl: true,
    //   bid: '',
    // },
    {
      code: 'about',
      text: '了解美团',
      linkUrl: '/about/ourTeam',
      bid: 'b_ead_dpl42clj_mc',
    },
    // {
    //   code: 'question',
    //   text: '常见问题',
    //   linkUrl: '/question/social',
    //   bid: 'b_ead_7qj3h4gs_mc',
    // },
    {
      code: 'personalCenter',
      text: '个人中心',
      linkUrl: '/personal-center/resume-detail',
      bid: 'b_ead_k9bx2myi_mc',
    },
  ];
  // 跳转登录
  function login() {
    goCallback && goCallback();
    if (window.location.pathname !== '/m/login') {
      go(`/login`, { redirectUrl: encodeURIComponent(window.location.href) }, { isAppendQuery: false });
    }
  }
  // 登出
  async function logout() {
    LxSiteClick({ bid: 'b_ead_f3nxm0ax_mc' });
    goCallback && goCallback();
    await loginStore.userLogout();
    Toast.show({
      content: '退出成功',
      duration: 3000,
    });
    // 退出成功后跳转首页
    go('/home');
  }
  // 跳转个人中心
  function goPersonalCenter() {
    goCallback && goCallback();
    go('/personal-center/resume-detail');
  }
  // 跳转英文网站
  const renderLangBtn = () => (
    <Button
      type="secondary"
      className="langs-btn"
      onClick={() => {
        const { origin } = window.location;
        const isTest = origin.includes('it.test');
        const isWeixin = isWeiXin();
        // eslint-disable-next-line no-nested-ternary
        const prodUrl = isWeixin
          ? 'https://careers.meituan.com/en'
          : buildEnv === 'overseas'
            ? window.location.origin
            : 'https://careers.keeta-global.com';
        const url = !isTest ? prodUrl : `${origin}/en`;
        window.open(url, '_blank');
      }}
    >
      English
    </Button>
  );

  return (
    <div className="zp_header_navBar">
      <div className="logoWrap">
        <img src="//s3plus.meituan.net/zhaopin-official-website-mobile-prod/common/logo.png" alt="" />
      </div>
      {navList.map((item) => {
        const isExpanded = expandedMenu === item.code;
        return (
          <div key={item.text} className="navItemWrap">
            <div
              className={`listWrap ${item.children ? 'hasChildren' : ''}`}
              onClick={() => {
                if (item.children) {
                  // 有子菜单则切换展开/收起
                  setExpandedMenu(isExpanded ? null : item.code);
                } else {
                  // 没有子菜单则直接跳转
                  goCallback && goCallback();
                  if (item.linkUrl) {
                    LxSiteClick({ bid: item.bid });
                    if (item.linkUrl.startsWith('http')) {
                      window.open(item.linkUrl, '_blank');
                    } else if (location.pathname !== item.linkUrl) {
                      if (location.pathname === '/share-position' && isIos() && isWeiXin()) {
                        jump(`/m${item.linkUrl}`);
                      } else {
                        go(item.linkUrl, undefined, { isfullUrl: item.isfullUrl });
                      }
                    }
                  }
                }
              }}
            >
              {item.text}
              {item.children && <span className={`arrow ${isExpanded ? 'expanded' : ''}`} />}
            </div>
            {item.children && isExpanded && (
              <div className="submenuWrap">
                {item.children.map((child) => (
                  <div
                    key={child.text}
                    className="submenuItem"
                    onClick={() => {
                      goCallback && goCallback();
                      LxSiteClick({ bid: item.bid });
                      if (child.isExternal) {
                        window.open(child.linkUrl, '_self');
                      } else if (location.pathname !== child.linkUrl) {
                        go(child.linkUrl, undefined, { isfullUrl: item.isfullUrl });
                      }
                      setExpandedMenu(null);
                    }}
                  >
                    {child.text}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      {isLogin ? (
        <div className="userInfoWrap">
          <img
            className="avatar"
            src={avatar || avatarImg}
            alt=""
            onClick={() => {
              LxSiteClick({ bid: 'b_ead_k9bx2myi_mc' });
              goPersonalCenter();
            }}
          />
          <Button
            className="logoutBtn"
            type="secondary"
            onClick={() => {
              logout();
            }}
          >
            退出登录
          </Button>
          {renderLangBtn()}
        </div>
      ) : (
        <div className="bottomWrap">
          <Button
            className="loginBtn"
            type="primary"
            onClick={() => {
              LxSiteClick({ bid: 'b_ead_z9lnbshl_mc' });
              login();
            }}
          >
            登录
          </Button>
          {renderLangBtn()}
        </div>
      )}
    </div>
  );
}
